import { render, staticRenderFns } from "./EMRVersionList.vue?vue&type=template&id=21350608&scoped=true"
import script from "./EMRVersionList.vue?vue&type=script&lang=js"
export * from "./EMRVersionList.vue?vue&type=script&lang=js"
import style0 from "./EMRVersionList.vue?vue&type=style&index=0&id=21350608&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21350608",
  null
  
)

export default component.exports